import { useCallback } from 'react';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { NavigationTabOption } from '../@types';
import { useMarketplace } from './useMarketplace';

const useFeatureFlaggedTabs = () => {
  const growthbook = useGrowthBook();
  const { config, isStandaloneCasino } = useMarketplace();

  const filterFeatureFlaggedTabs = useCallback(
    (tabs: NavigationTabOption[]) => {
      return tabs.filter((tab) => {
        if (tab.requireSportsbook && isStandaloneCasino) {
          return false;
        }

        if (tab.requireCasino && config?.marketplaceConfig?.products?.casino !== true) {
          return false;
        }

        if (tab.featureFlag) {
          if (!growthbook?.isOn(tab.featureFlag)) {
            return false;
          }
        }

        if (tab.casinoConfigFlag && !config?.casinoConfig?.[tab.casinoConfigFlag]) {
          return false;
        }

        // Shared parent tabs stay visible in mixed marketplaces when their Sportsbook child remains available.
        if (
          isStandaloneCasino &&
          tab.standaloneCasinoConfigFlag &&
          (config?.marketplaceConfig?.products?.casino !== true ||
            !config?.casinoConfig?.[tab.standaloneCasinoConfigFlag])
        ) {
          return false;
        }

        if (tab.marketplaceSystemFlag) {
          const systemEnabled = config?.marketplaceConfig?.systems?.[tab.marketplaceSystemFlag];

          if (!systemEnabled) {
            return false;
          }
        }

        if (isStandaloneCasino && tab.standaloneCasinoSystemFlag) {
          const standaloneSystemEnabled = config?.marketplaceConfig?.systems?.[tab.standaloneCasinoSystemFlag];

          if (!standaloneSystemEnabled) {
            return false;
          }
        }

        return true;
      });
    },
    [growthbook, config, isStandaloneCasino]
  );

  return { filterFeatureFlaggedTabs };
};

export default useFeatureFlaggedTabs;
